import Vue from "vue";
import Router from "vue-router";
import Home from "../../home/Home.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/coach",
      name: "coach",
      component: () => import("../../coach/Coach.vue")
    },
    {
      path: "/ourStory",
      name: "ourStory",
      component: () => import("../../ourStory/OurStory.vue")
    }
  ]
});
